/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-ignore */
// @ts-nocheck
import React from 'react';

import {
  Container,
  TolltipItens,
  TooltipContainer,
  TootipTitle,
} from './styles';

const PasswordForceMobile: React.FC = () => {
  return (
    <Container>
      <TooltipContainer>
        <TootipTitle>Requisitos de senha</TootipTitle>
        <TolltipItens>
          <ul>
            <li>
              Deve ter, no mínimo, <b> 8 caracteres</b>.
            </li>
            <li>
              Deve ter pelo menos <b>uma letra maiúscula</b>.
            </li>
            <li>
              Deve ter pelo menos <b>uma letra minúscula</b>.
            </li>
            <li>
              Deve ter pelo menos <b>um número</b>.
            </li>
            <li>
              Deve ter pelo menos <b>um caractere especial (!@#$)</b>.
            </li>
            <li>Não utilizar a última senha cadastrada.</li>
          </ul>
        </TolltipItens>
      </TooltipContainer>
    </Container>
  );
};

export default PasswordForceMobile;
